import { useUrlState } from "../../../../hooks/useUrlState.js";
import { MAIL_VIEWS, OPEN_MAIL_URL_KEY } from "../../constants.js";
import { useMailStore } from "../../stores/MailStore.js";
import { MailSectionsBottomMenu } from "./components/MailSectionsBottomMenu/index.js";
import { MailMessageForm } from "../../components/MailMessageForm/index.js";
import { MailMessageDisplay } from "./components/MailMessageDisplay/index.js";
import { MailMessageListDisplay } from "./components/MailMessageListDisplay/index.js";
import { useCallback } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
// src/modules/Mail/screens/MailSidebarScreen/index.tsx
var ContentComponents = ({ onClickMailMessageItem, onNewMailComplete, openMailBackComplete, openMailDeleteComplete, openMailId }) => {
	const view = useMailStore((state) => state.view);
	if (view === MAIL_VIEWS.NEW) return /* @__PURE__ */ jsx(MailMessageForm, { onComplete: onNewMailComplete });
	if (view === MAIL_VIEWS.OPEN && openMailId) return /* @__PURE__ */ jsx(MailMessageDisplay, {
		messageId: openMailId,
		onBack: openMailBackComplete,
		onDeleteMessage: openMailDeleteComplete
	});
	return /* @__PURE__ */ jsx(MailMessageListDisplay, { onClickMailMessage: onClickMailMessageItem });
};
var MailSidebarScreen = () => {
	const folder = useMailStore((state) => state.folder);
	const setView = useMailStore((state) => state.setView);
	const [openMailMessageId, setOpenMailMessageId] = useUrlState(OPEN_MAIL_URL_KEY);
	const goBack = useCallback(() => setView(folder), [folder]);
	const handleClickMailItem = useCallback((messageId) => {
		setOpenMailMessageId(messageId);
		setView(MAIL_VIEWS.OPEN);
	}, []);
	return /* @__PURE__ */ jsxs("div", {
		className: "flex h-full flex-col",
		children: [/* @__PURE__ */ jsx("div", {
			className: "p-base grow",
			children: /* @__PURE__ */ jsx(ContentComponents, {
				onClickMailMessageItem: handleClickMailItem,
				onNewMailComplete: goBack,
				openMailBackComplete: goBack,
				openMailDeleteComplete: goBack,
				openMailId: openMailMessageId
			})
		}), /* @__PURE__ */ jsx(MailSectionsBottomMenu, {})]
	});
};
export { MailSidebarScreen };

//# sourceMappingURL=index.js.map